<template>
    <div v-if="questao" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes da Questão de Avaliação</h4>
        <router-link to="/configuracoes/parametros-avaliacoes/questoes">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
      <div class="form-content mt-3">
        <FormSection title="">
          <p><strong>Categoria de Avaliação:</strong> {{ questao.categoria_nome || 'Não informado' }}</p>
          <p><strong>Bloco da Questão:</strong> {{ questao.bloco_nome || 'Não informado' }}</p>
          <p><strong>Questão:</strong> {{ questao.questao || 'Não informado' }}</p>
          <p><strong>Tipo de Dado:</strong> {{ questao.tipo_dado || 'Não informado' }}</p>
          <p><strong>Ativo:</strong> {{ questao.ativo ? 'Sim' : 'Não' }}</p>
          <p><strong>Criado em:</strong> {{ formatarData(questao.criado_em) }}</p>
          <p><strong>Atualizado em:</strong> {{ formatarData(questao.atualizado_em) }}</p>
        </FormSection>
      </div>
    </div>
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  
  export default {
    components: { FormSection },
    data() {
      return {
        questao: null,
      };
    },
    methods: {
      async carregarDetalhesQuestao() {
        try {
          const response = await axios.get(`/configuracoes/parametros-avaliacoes/questoes/${this.$route.params.id}`);
          this.questao = response.data;
        } catch (error) {
          console.error("Erro ao carregar os detalhes da questão:", error);
        }
      },
      formatarData(data) {
        if (!data) return "Não informado";
        return new Date(data).toLocaleString();
      },
    },
    mounted() {
      this.carregarDetalhesQuestao();
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0rem;
  }
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  .form-content {
    margin-top: 1.5rem;
  }
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
  